import React, { useCallback, useContext, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';

import AuthContext from '../modules/contexts/Auth';
import { HOME, SIGNIN_KAKAO, SIGNUP } from '../lib/routes/path';
import { ERROR_CS } from '../lib/Error';
import { BABYFACE_URL } from '../lib/routes/Routes';

const KakaoCallbackPage = () => {
  const {
    state: { logged },
    actions: { setLogged },
  } = useContext(AuthContext);
  const location = useLocation();
  const code = location.search.split('code=')[1];

  const data = {
    grant_type: 'authorization_code',
    client_id: process.env.REACT_APP_KAKAO_RESTAPI_KEY,
    redirect_uri: `${window.location.origin}${SIGNIN_KAKAO}`,
    code,
  };

  const postKakaoLogin = useCallback(async (accessToken) => {
    await axios
      .post(
        `${BABYFACE_URL}/social/login/kakao?accessToken=${accessToken}&businessName=BABYFACE`,
      )
      .then((response) => {
        const { accessToken } = response.data;
        axios.defaults.headers.common.Authorization = accessToken;
        sessionStorage.accessToken = accessToken;
        setLogged();
      })
      .catch(() => {
        alert(`베이비페이스 로그인 도중 에러가 발생했습니다.\n${ERROR_CS}`);
        window.location.replace(SIGNUP);
      });
  }, []);

  const getKakaoToken = useCallback(async () => {
    await axios
      .post('https://kauth.kakao.com/oauth/token', qs.stringify(data), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
      })
      .then((response) => {
        postKakaoLogin(response.data.access_token);
      })
      .catch(() => {
        alert(`카카오 로그인 도중 에러가 발생했습니다.\n${ERROR_CS}`);
        window.location.replace(SIGNUP);
      });
  }, [code]);

  useEffect(() => {
    getKakaoToken();
  }, []);

  return (
    <>
      {logged && (
        <>
          {sessionStorage.nPrevUrl ? (
            <Redirect to={sessionStorage.nPrevUrl} />
          ) : (
            <Redirect to={HOME} />
          )}
        </>
      )}
      <div />
    </>
  );
};

export default KakaoCallbackPage;
